<template>
  <div id="tourists_input" class="tourists-input-wrapper">
    <div v-if="show_selector" class="dropdown-closer" @click="toggle_selector"></div>
    <input :value="humanized_string"
           id="tourists-input"
                :class="css_classes"
                placeholder="Укажите количество"
                @click="toggle_selector"
                readonly
    >
    <b-tooltip target="tourists-input" triggers="hover" v-if="min_age">
      {{min_age_message}}
    </b-tooltip>
    <tourists-selector v-if="show_selector"
                       :tourists="localTourists"
                       :min_age="min_age"
                       @change="on_change_tourists"
    />

  </div>
</template>
<script>
  import TouristsSelector from "./TouristsSelector";
  import { humanized_tourists } from "../../../components/shared/helpers";

  export default {
    components: { TouristsSelector },
    props:['tourists', 'min_age'],
    data() {
      return {
        localTourists: this.tourists,
        show_selector: false
      }
    },
    computed: {
      min_age_message(){
        if (this.min_age == undefined) return '';
        const word = ((this.min_age % 10) == 1) ? 'года' : 'лет'
        return `c ${this.min_age} ${word}`
      },
      css_classes(){
        let css = 'form-control tourists-input';
        if (this.show_selector) {
          css+= ' active'
        }
        return css;
      },
      humanized_string() {
        return humanized_tourists(this.localTourists.adults, this.localTourists.kids);
      }
    },
    methods: {
      on_change_tourists(obj){
        this.$emit('change', obj);
      },
      toggle_selector(){
        this.$set(this, 'show_selector', !this.show_selector);
      },
    }
  }
</script>

